export default __webpack_public_path__ + "static/media/attachment.009d96a4.svg";